import { render, staticRenderFns } from "./tuandco-facets-tick.vue?vue&type=template&id=c215c656&scoped=true&functional=true&"
var script = {}
import style0 from "./tuandco-facets-tick.vue?vue&type=style&index=0&id=c215c656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "c215c656",
  null
  
)

export default component.exports